import script from "./SearchResultOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchResultOrder.vue?vue&type=script&setup=true&lang=js"

import "./SearchResultOrder.vue?vue&type=style&index=0&id=18476b8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18476b8e"]])

export default __exports__